module.exports = __webpack_public_path__ + "img/symbol_10.72f09c8a.png";